export default {
    en: {
        attachment: {
            clickToDownload: 'Click to download',
            noAttachment: 'There is no attachment',
        },
        bookmark: {
            noBookmark: 'There is no bookmark',
        },
        core: {
            askingPassword: {
                requirePasswordToOpen: 'This document requires a password to open',
                submit: 'Submit',
            },
            wrongPassword: {
                submit: 'Submit',
                tryAgain: 'The password is wrong. Please try again',
            },
        },
        defaultLayout: {
            attachment: 'Attachment',
            bookmark: 'Bookmark',
            thumbnail: 'Thumbnail',
        },
        download: {
            download: 'Download',
        },
        drop: {
            dragDropFile: 'Drag and drop a PDF document here',
        },
        fullScreen: {
            enterFullScreen: 'Full screen',
        },
        localeSwitcher: {
            switchLocale: 'Switch locale',
        },
        open: {
            openFile: 'Open file',
        },
        pageNavigation: {
            goToFirstPage: 'First page',
            goToLastPage: 'Last page',
            goToNextPage: 'Next page',
            goToPreviousPage: 'Previous page',
        },
        print: {
            cancel: 'Cancel',
            preparingDocument: 'Preparing document ...',
            print: 'Print',
        },
        properties: {
            author: 'Author',
            close: 'Close',
            creationDate: 'Creation date',
            creator: 'Creator',
            fileName: 'File name',
            fileSize: 'File size',
            keywords: 'Keywords',
            modificationDate: 'Modification date',
            pageCount: 'Page count',
            pdfProducer: 'PDF producer',
            pdfVersion: 'PDF version',
            showProperties: 'Show properties',
            subject: 'Subject',
            title: 'Title',
        },
        rotate: {
            rotateBackward: 'Rotate counterclockwise',
            rotateForward: 'Rotate clockwise',
        },
        scrollMode: {
            horizontalScrolling: 'Horizontal scrolling',
            verticalScrolling: 'Vertical scrolling',
            wrappedScrolling: 'Wrapped scrolling',
        },
        search: {
            close: 'Close',
            enterToSearch: 'Enter to search',
            matchCase: 'Match case',
            nextMatch: 'Next match',
            previousMatch: 'Previous match',
            search: 'Search',
            wholeWords: 'Whole words',
        },
        selectionMode: {
            handTool: 'Hand tool',
            textSelectionTool: 'Text selection tool',
        },
        toolbar: {
            moreActions: 'More actions',
        },
        zoom: {
            actualSize: 'Actual size',
            pageFit: 'Page fit',
            pageWidth: 'Page width',
            zoomIn: 'Zoom in',
            zoomOut: 'Zoom out',
        },
        slideShowMode: 'Slideshow',
    },
    es: {
        attachment: {
            clickToDownload: 'Click to download',
            noAttachment: 'There is no attachment',
        },
        bookmark: {
            noBookmark: 'There is no bookmark',
        },
        core: {
            askingPassword: {
                requirePasswordToOpen: 'This document requires a password to open',
                submit: 'Submit',
            },
            wrongPassword: {
                submit: 'Submit',
                tryAgain: 'The password is wrong. Please try again',
            },
        },
        defaultLayout: {
            attachment: 'Attachment',
            bookmark: 'Bookmark',
            thumbnail: 'Miniaturas',
        },
        download: {
            download: 'Descargar',
        },
        drop: {
            dragDropFile: 'Drag and drop a PDF document here',
        },
        fullScreen: {
            enterFullScreen: 'Pantalla completa',
        },
        localeSwitcher: {
            switchLocale: 'Switch locale',
        },
        open: {
            openFile: 'Open file',
        },
        pageNavigation: {
            goToFirstPage: 'First page',
            goToLastPage: 'Last page',
            goToNextPage: 'Página siguiente',
            goToPreviousPage: 'Página anterior',
        },
        print: {
            cancel: 'Cancelar',
            preparingDocument: 'Preparando el documento..',
            print: 'Imprimir',
        },
        properties: {
            author: 'Author',
            close: 'Close',
            creationDate: 'Creation date',
            creator: 'Creator',
            fileName: 'File name',
            fileSize: 'File size',
            keywords: 'Keywords',
            modificationDate: 'Modification date',
            pageCount: 'Page count',
            pdfProducer: 'PDF producer',
            pdfVersion: 'PDF version',
            showProperties: 'Show properties',
            subject: 'Subject',
            title: 'Title',
        },
        rotate: {
            rotateBackward: 'Rotate counterclockwise',
            rotateForward: 'Rotate clockwise',
        },
        scrollMode: {
            horizontalScrolling: 'Horizontal scrolling',
            verticalScrolling: 'Vertical scrolling',
            wrappedScrolling: 'Wrapped scrolling',
        },
        search: {
            close: 'Cerrar',
            enterToSearch: 'Entre para buscar',
            matchCase: 'Mayús/Minus',
            nextMatch: 'Siguiente',
            previousMatch: 'Anterior',
            search: 'Buscar',
            wholeWords: 'Palabras enteras',
        },
        selectionMode: {
            handTool: 'Hand tool',
            textSelectionTool: 'Text selection tool',
        },
        toolbar: {
            moreActions: 'More actions',
        },
        zoom: {
            actualSize: 'Tamaño actual',
            pageFit: 'Encajar página',
            pageWidth: 'Encajar ancho',
            zoomIn: 'Aumentar',
            zoomOut: 'Alejar',
        },
        slideShowMode: 'Presentación',
    },
    de: {
        attachment: {
            clickToDownload: 'Click to download',
            noAttachment: 'There is no attachment',
        },
        bookmark: {
            noBookmark: 'There is no bookmark',
        },
        core: {
            askingPassword: {
                requirePasswordToOpen: 'This document requires a password to open',
                submit: 'Submit',
            },
            wrongPassword: {
                submit: 'Submit',
                tryAgain: 'The password is wrong. Please try again',
            },
        },
        defaultLayout: {
            attachment: 'Attachment',
            bookmark: 'Bookmark',
            thumbnail: 'Miniaturansicht',
        },
        download: {
            download: 'Herunterladen',
        },
        drop: {
            dragDropFile: 'Drag and drop a PDF document here',
        },
        fullScreen: {
            enterFullScreen: 'Vollbild',
        },
        localeSwitcher: {
            switchLocale: 'Switch locale',
        },
        open: {
            openFile: 'Open file',
        },
        pageNavigation: {
            goToFirstPage: 'First page',
            goToLastPage: 'Last page',
            goToNextPage: 'Nächste Seite',
            goToPreviousPage: 'Vorherige Seite',
        },
        print: {
            cancel: 'Stornieren',
            preparingDocument: 'Dokument vorbereiten ...',
            print: 'Drucken',
        },
        properties: {
            author: 'Author',
            close: 'Close',
            creationDate: 'Creation date',
            creator: 'Creator',
            fileName: 'File name',
            fileSize: 'File size',
            keywords: 'Keywords',
            modificationDate: 'Modification date',
            pageCount: 'Page count',
            pdfProducer: 'PDF producer',
            pdfVersion: 'PDF version',
            showProperties: 'Show properties',
            subject: 'Subject',
            title: 'Title',
        },
        rotate: {
            rotateBackward: 'Rotate counterclockwise',
            rotateForward: 'Rotate clockwise',
        },
        scrollMode: {
            horizontalScrolling: 'Horizontal scrolling',
            verticalScrolling: 'Vertical scrolling',
            wrappedScrolling: 'Wrapped scrolling',
        },
        search: {
            close: 'Schließen',
            enterToSearch: 'Geben Sie ein, um zu suchen',
            matchCase: 'Match case',
            nextMatch: 'Nächster',
            previousMatch: 'Bisherige',
            search: 'Suche',
            wholeWords: 'Ganze Wörter',
        },
        selectionMode: {
            handTool: 'Hand tool',
            textSelectionTool: 'Text selection tool',
        },
        toolbar: {
            moreActions: 'More actions',
        },
        zoom: {
            actualSize: 'Tatsächliche Größe',
            pageFit: 'Seitenanpassung',
            pageWidth: 'Seitenbreite',
            zoomIn: 'Hineinzoomen',
            zoomOut: 'Rauszoomen',
        },
        slideShowMode: 'Diashow',
    },
    fr: {
        attachment: {
            clickToDownload: 'Click to download',
            noAttachment: 'There is no attachment',
        },
        bookmark: {
            noBookmark: 'There is no bookmark',
        },
        core: {
            askingPassword: {
                requirePasswordToOpen: 'This document requires a password to open',
                submit: 'Submit',
            },
            wrongPassword: {
                submit: 'Submit',
                tryAgain: 'The password is wrong. Please try again',
            },
        },
        defaultLayout: {
            attachment: 'Attachment',
            bookmark: 'Bookmark',
            thumbnail: 'La vignette',
        },
        download: {
            download: 'Télécharger',
        },
        drop: {
            dragDropFile: 'Drag and drop a PDF document here',
        },
        fullScreen: {
            enterFullScreen: 'Plein écran',
        },
        localeSwitcher: {
            switchLocale: 'Switch locale',
        },
        open: {
            openFile: 'Open file',
        },
        pageNavigation: {
            goToFirstPage: 'First page',
            goToLastPage: 'Last page',
            goToNextPage: 'Page suivante',
            goToPreviousPage: 'Page précédente',
        },
        print: {
            cancel: 'Annuler',
            preparingDocument: 'Préparation du document ...',
            print: 'Imprimer',
        },
        properties: {
            author: 'Author',
            close: 'Close',
            creationDate: 'Creation date',
            creator: 'Creator',
            fileName: 'File name',
            fileSize: 'File size',
            keywords: 'Keywords',
            modificationDate: 'Modification date',
            pageCount: 'Page count',
            pdfProducer: 'PDF producer',
            pdfVersion: 'PDF version',
            showProperties: 'Show properties',
            subject: 'Subject',
            title: 'Title',
        },
        rotate: {
            rotateBackward: 'Rotate counterclockwise',
            rotateForward: 'Rotate clockwise',
        },
        scrollMode: {
            horizontalScrolling: 'Horizontal scrolling',
            verticalScrolling: 'Vertical scrolling',
            wrappedScrolling: 'Wrapped scrolling',
        },
        search: {
            close: 'Fermer',
            enterToSearch: 'Entrez pour rechercher',
            matchCase: 'Match case',
            nextMatch: 'Prochain match',
            previousMatch: 'Match précédent',
            search: 'Rechercher',
            wholeWords: 'Mots entiers',
        },
        selectionMode: {
            handTool: 'Hand tool',
            textSelectionTool: 'Text selection tool',
        },
        toolbar: {
            moreActions: 'More actions',
        },
        zoom: {
            actualSize: 'Taille actuelle',
            pageFit: 'Ajustement de page',
            pageWidth: 'Largeur de page',
            zoomIn: 'Agrandir',
            zoomOut: 'Dézoomer',
        },
        slideShowMode: 'Diaporama',
    },
};
